riot.tag2('checkout-modal', '<div class="selling-bankid-modal checkout-modal"> <div data-ng-if="!showBankIdProgress && !showBankIdError"> <header> <h2 class="heading-berlin">{opts.model.title}</h2> </header> <div> <div if="{opts.model.showProgressIcon}"> <svg class="d-flex m-auto icon icon-dark icon-xl icon-spin" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 16 16"> <path class="st0" d="M7.9 1c2.4 0 4.5 1.2 5.7 3.1l-.7.7C11.9 3.1 10 2 7.9 2 4.6 2 2 4.6 2 7.9s2.6 5.9 5.9 5.9 5.9-2.6 5.9-5.9V8h1c-.1 3.6-3 6.6-6.6 6.7H8c-3.9 0-7-3-7-6.8S4.1 1 7.9 1z"></path> <path class="st0" d="M14 2l-3 3h3z"></path> </svg> </div> <div if="{opts.model.showErrorIcon}" class="icon-error"></div> <div if="{opts.model.showSuccessIcon}" class="icon-check"></div> <div class="checkout-modal-text"> <article if="{opts.model.text}" class="grid-wrapper"> {opts.model.text} </article> <div if="{opts.model.bodyTagName}" class="bodyTagContent"></div> </div> <div if="{opts.model.buttons}" class="grid-wrapper"> <ol if="{opts.model.buttons.primary && opts.model.buttons.secondary}" class="grid-1-2 plain-list"> <li class="grid-item right"> <button class="btn btn-primary btn-fluid" onclick="{primaryClick}">{opts.model.buttons.primary.title}</button> </li> <li class="grid-item"> <button class="btn btn-outline-primary btn-fluid" onclick="{secondaryClick}">{opts.model.buttons.secondary.title}</button> </li> </ol> <ol if="{!opts.model.buttons.primary && opts.model.buttons.secondary}" class="plain-list"> <li> <button class="btn btn-primary btn-fluid" onclick="{secondaryClick}">{opts.model.buttons.secondary.title}</button> </li> </ol> </div> </div> </div> </div>', '', '', function(opts) {

        const self = this;

        this.on('mount',
            function() {
                if (opts.model.bodyTagName) {
                    riot.mount('.bodyTagContent', opts.model.bodyTagName, opts.model.bodyTagModel);
                }
                if (opts.model.subTitleHtml) {
                    riot.mount('raw', { html: opts.model.subTitleHtml });
                } else {
                    riot.mount('raw', { html: "" });
                }
            });

        riot.tag('raw',
            '',
            function(opts) {
                if (opts.html)
                    this.root.innerHTML = opts.html;
            });

        this.primaryClick = function() {
            if (opts.model.buttons.primary.click) {
                opts.model.buttons.primary.click(opts.model);
            } else {
                opts.model.close();
            }
        };

        this.secondaryClick = function() {
            if (opts.model.buttons.secondary.click) {
                opts.model.buttons.secondary.click(opts.model);
            } else {
                opts.model.close();
            }
        };

        this.opts.model.showError = function (title, text, action) {
            opts.model.showErrorIcon = true;
            opts.model.showProgressIcon = false;
            opts.model.title = title;
            opts.model.text = text;
            opts.model.buttons = {
                secondary: {
                    title: self.t('checkout_modal_ok'),
                    click: action ? action : null
                }
            };
            this.update();
        };

        this.opts.model.showSuccess = function(title, text, buttonText, action) {
            opts.model.showSuccessIcon = true;
            opts.model.showErrorIcon = false;
            opts.model.showProgressIcon = false;
            opts.model.title = title;
            opts.model.text = text;
            opts.model.buttons = {
                secondary: {
                    title: buttonText ? buttonText : self.t('checkout_modal_ok'),
                    click: action
                }
            };
            this.update();
        };

});
